import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  @media only screen and (max-width: 1200px) {
    flex-direction: column;
    justify-content: center;
    row-gap: 10px;
  }

  .type {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: ${colors.white};
    font-weight: 600;
    font-size: 16px;
    white-space: nowrap;
    letter-spacing: 1px;

    .icon {
      margin-left: 5px;
      cursor: pointer;
    }

    .grey {
      color: ${colors.grey};
      margin-right: 10px;
    }

    @media only screen and (min-width: 767px) and (max-width: 1200px) {
      font-size: 17px;
      justify-content: center;
    }

    @media only screen and (max-width: 767px) {
      width: 100%;
      font-weight: bold;
      justify-content: center;
      flex-wrap: wrap;
    }
  }
  
  ${({ additionalstyle }) => additionalstyle};
`;
